var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47059 1.25576C1.42147 1.25576 1.17647 1.26675 1.17647 1.48588V15.6131C1.17647 15.8182 1.34206 16.0109 1.47059 16.0109H15.1715H15.5947L15.9209 16.2988L18.5285 18.599V17.2667V16.0109H19.705H23.5294C23.6579 16.0109 23.8235 15.8182 23.8235 15.6128V1.48556C23.8235 1.26675 23.5785 1.25576 23.5294 1.25576H1.47059ZM1.47059 0H23.5294C24.3415 0 25 0.619089 25 1.48588V15.6131C25 16.4803 24.3415 17.2667 23.5294 17.2667H19.705V20.2899C19.705 20.633 19.5712 20.8333 19.3729 20.8333C19.2718 20.8333 19.1538 20.7812 19.0282 20.6691L15.1715 17.2667H1.47059C0.658234 17.2667 -1.90735e-06 16.4802 -1.90735e-06 15.6128V1.48556C-1.90735e-06 0.619089 0.658234 0 1.47059 0Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.24967,
    cy: 8.7526,
    r: 1.66667,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4997,
    cy: 8.7526,
    r: 1.66667,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7497,
    cy: 8.7526,
    r: 1.66667,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chatBubble.7cabd6fc4ba97c3e035b5619cf70cd67.svg";
export { ForwardRef as ReactComponent };